import React from 'react';
import { useEffect } from "react";

const AboutPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []); 

  return (
    <main className="pt-20 bg-white dark:bg-gray-900 min-h-screen">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
          <div className="grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white leading-tight">
                Building Digital Products that Move Businesses Forward
              </h1>
              <p className="mt-4 text-gray-600 dark:text-gray-300 md:text-lg">
                Codepact is a product and technology partner helping companies design, build, and scale
                modern software with beautiful experiences and reliable engineering.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <span className="px-4 py-2 rounded-full bg-primary-100 text-primary-700 dark:bg-primary-900/20 dark:text-primary-300 text-sm font-semibold">Web Apps</span>
                <span className="px-4 py-2 rounded-full bg-accent-100 text-accent-700 dark:bg-accent-900/20 dark:text-accent-300 text-sm font-semibold">Mobile</span>
                <span className="px-4 py-2 rounded-full bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 text-sm font-semibold">Cloud & DevOps</span>
              </div>
            </div>
            <div className="relative">
              <div className="rounded-2xl overflow-hidden shadow-2xl">
                <img src="/aboutpage2.jpg" alt="Codepact Team" className="w-full h-[360px] object-cover aspect-[4/3]" />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-primary-400/20 rounded-full"></div>
              <div className="absolute -top-6 -right-2 w-14 h-14 bg-gray-400/30 rounded-lg"></div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </section>

      {/* Mission & Vision */}
      <section className="py-12 md:py-16 bg-blue-50 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-8">
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow border border-gray-200/50 dark:border-gray-700/50">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Our Mission</h2>
            <p className="mt-3 text-gray-600 dark:text-gray-300">
              Deliver business impact through thoughtful design, robust engineering, and
              a partnership mindset. We help teams ship faster with quality that lasts.
            </p>
            <ul className="mt-5 space-y-2 text-sm text-gray-600 dark:text-gray-300">
              <li className="flex items-center gap-2"><span className="w-2 h-2 bg-[#0284c7] rounded-full"></span> Human-centered experiences</li>
              <li className="flex items-center gap-2"><span className="w-2 h-2 bg-[#0284c7] rounded-full"></span> Measurable product outcomes</li>
              <li className="flex items-center gap-2"><span className="w-2 h-2 bg-[#0284c7] rounded-full"></span> Sustainable engineering practices</li>
            </ul>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow border border-gray-200/50 dark:border-gray-700/50">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Our Vision</h2>
            <p className="mt-3 text-gray-600 dark:text-gray-300">
              Create a world where technology is a trusted accelerator. We aim to be the partner
              companies call when they need clarity, velocity, and craftsmanship.
            </p>
            <div className="mt-5 grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-2xl font-bold gradient-text">500+</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Projects</div>
              </div>
              <div>
                <div className="text-2xl font-bold gradient-text">200+</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Clients</div>
              </div>
              <div>
                <div className="text-2xl font-bold gradient-text">5 yrs</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

    

      {/* Section Divider */}
      <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* Timeline - Expanded Years */}
      <section className="py-12 md:py-16 bg-gray-100 dark:bg-gray-800/40">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">Our Journey</h2>
          <div className="mt-10 relative">
            <div className="absolute left-2 md:flex hidden md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-primary-500 dark:via-primary-300 to-transparent"></div>
            <div className="space-y-8">
              {[
                {year:'2020',title:'Founded Codepact',desc:'Started with a small team focused on modern web delivery and rapid iteration.'},
                {year:'2021',title:'First Milestones',desc:'Launched 20+ projects; established design system and component library.'},
                {year:'2022',title:'Scaled Delivery',desc:'Introduced mobile, cloud, and QA practices; expanded to new industries.'},
                {year:'2023',title:'Platform Thinking',desc:'Evolved into multi-product squads with shared tooling and CI/CD.'},
                {year:'2024',title:'Global Clients',desc:'Delivered across e‑commerce, fintech, and health; strengthened security posture.'},
                {year:'2025',title:'Acceleration',desc:'Investing in data, AI-readiness, and performance engineering at scale.'}
              ].map((t, i) => (
                <div key={i} className="md:grid md:grid-cols-2 md:gap-8 items-start">
                  <div className={`md:text-right text-center md-mb-0 mb-3 ${i%2===0 ? 'md:order-1' : 'md:order-none'}`}>
                    <div className="block px-3 py-1 rounded-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 text-xs font-semibold text-gray-700 dark:text-gray-300">{t.year}</div>
                  </div>

                 
                  <div className="bg-white dark:bg-gray-900 rounded-xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                    <h3 className="font-semibold text-gray-900 dark:text-white">{t.title}</h3>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{t.desc}</p>
                    <ul className="mt-3 grid sm:grid-cols-2 gap-2 text-xs text-gray-600 dark:text-gray-300">
                      <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span> Key launches and learnings</li>
                      <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-[#0284c7] rounded-full"></span> Team growth and practices</li>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* Our Culture */}
      <section className="py-10 md:py-14 bg-blue-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">Our Culture</h2>
          <div className="mt-10 grid lg:grid-cols-2 gap-6 items-start">
            {/* Culture points */}
            <div className="grid md:grid-cols-2 gap-6">
              {[
  {
    title: 'Ownership',
    desc: 'We take full responsibility for our work—from idea to execution. Team members has to make decisions, the courage to take initiative.'
  },
  {
    title: 'Craft',
    desc: 'Our design and engineering practices emphasize precision, creativity that delight our customers every day.'},
  {
    title: 'Learning',
    desc: 'We are lifelong learners who embrace curiosity and growth. Through open reviews, collaborative pairing, and evolving playbooks.'
  },
  {
    title: 'Respect',
    desc: 'We foster an environment where everyone’s ideas and perspectives are valued. Respect means listening actively & collaborating empathy.'
  }
].map((c, i) => (
                <div key={i} className="bg-white dark:bg-gray-900 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                  <h3 className="font-semibold text-gray-900 dark:text-white">{c.title}</h3>
                  <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{c.desc}</p>
                </div>
              ))}
            </div>
            {/* Side image */}
            <div className="rounded-2xl overflow-hidden shadow border border-gray-200 dark:border-gray-700">
              <img src="/aboutpage4.jpeg" alt="Codepact culture" className="w-full md:h-[347px] h-[220px] object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

        {/* What we do better */}
        <section className="py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">What Sets Us Apart</h2>
          <div className="mt-10 grid md:grid-cols-3 gap-6">
            {[
              {title:'Product Thinking',desc:'We align technology with business outcomes, not the other way around.'},
              {title:'Design Depth',desc:'Accessible, inclusive, and elegant UX that increases adoption.'},
              {title:'Operational Excellence',desc:'CI/CD, observability, and security built-in from day one.'}
            ].map((item, i) => (
              <div key={i} className="bg-blue-50 dark:bg-gray-800 rounded-2xl p-6 shadow border border-gray-200/50 dark:border-gray-700/50">
                <div className="w-12 h-12 rounded-xl bg-[#0284c7] text-white flex items-center justify-center mb-4">
                  <span className="font-bold">{i+1}</span>
                </div>
                <h3 className="font-semibold text-gray-900 dark:text-white">{item.title}</h3>
                <p className="mt-2 text-gray-600 dark:text-gray-300 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


        {/* Section Divider */}
        <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* How We Work */}
      <section className="py-8 md:py-12 bg-blue-50 dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">How We Work</h2>
          <div className="mt-10 grid lg:grid-cols-2 gap-8 items-start">
            {/* Left image */}
            <div className="rounded-2xl overflow-hidden shadow border border-gray-200 dark:border-gray-700">
              <img src="/aboutpage3.webp" alt="How we work" className="w-full md:h-[410px] h-[220px] object-cover" />
            </div>
            {/* Right points */}
            <div className="grid md:grid-cols-2 gap-6">
              {[
                {title:'Collaboration',desc:'Weekly demos, transparency, and shared goals to maintain quality.'},
                {title:'Quality',desc:'Code reviews, automated checks, and design QA ensure reliability.'},
                {title:'Communication',desc:'Clear async updates and tight feedback loops reduce surprises.'},
                {title:'Security',desc:'Best practices for auth, data protection, and dependency.'},
                {title:'Performance',desc:'Budgets, observability, and profiling guide decisions.'},
                {title:'Transparency',desc:'Open metrics on scope, timeline, and risks.'}
              ].map((item, i) => (
                <div key={i} className="bg-white dark:bg-gray-800 rounded-2xl p-6 border border-gray-200 dark:border-gray-700 shadow">
                  <h3 className="font-semibold text-gray-900 dark:text-white">{item.title}</h3>
                  <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="px-4">
        <div className="max-w-7xl mx-auto h-px bg-gradient-to-r from-transparent via-primary-300 dark:via-primary-600 to-transparent"></div>
      </div>

      {/* FAQs */}
      <section className="py-10 bg-gray-100 dark:bg-gray-900  md:py-14">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white text-center">FAQs</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-6">
            {[
  {
    q: 'How quickly can you start?',
    a: 'Typically within 1–2 weeks depending on project scope, complexity, and team availability. We move fast once objectives and requirements are aligned.'
  },
  {
    q: 'Do you sign NDAs?',
    a: 'Yes. We regularly execute mutual NDAs and comply with strict information security protocols to protect your intellectual property and data.'
  },
  {
    q: 'How do you estimate projects?',
    a: 'We provide detailed scope options with clear time and cost ranges, assumptions, and identified risks—ensuring full transparency before kickoff.'
  },
  {
    q: 'What does success look like?',
    a: 'Success means meeting defined KPIs, delivering frequent releases, and achieving measurable user and business outcomes.'
  },
  {
    q: 'How do you communicate during a project?',
    a: 'We maintain consistent communication through weekly check-ins, progress reports, and shared dashboards, ensuring full visibility at every stage.'
  },
  {
    q: 'Do you work with existing internal teams?',
    a: 'Absolutely. We often collaborate with in-house designers, engineers, and product owners to integrate seamlessly and accelerate outcomes.'
  },
  {
    q: 'What technologies do you use?',
    a: 'Our teams specialize in modern web and mobile stacks including React, Node.js, Next.js, Python, and cloud platforms like AWS and Azure.'
  },
  {
    q: 'Can we make changes during development?',
    a: 'Yes. We embrace agile processes, allowing scope adjustments with clear communication about impact on timelines and budgets.'
  },
  {
    q: 'Do you offer post-launch support?',
    a: 'Yes. We provide maintenance, performance monitoring, and iterative improvements after launch to ensure long-term success.'
  },
  {
    q: 'How do you handle billing and payments?',
    a: 'We offer flexible models including fixed-price, time-and-materials, or milestone-based billing—depending on your project needs and preferences.'
  }
]
.map((f, i) => (
              <details key={i} className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-5">
                <summary className="cursor-pointer font-medium text-gray-900 dark:text-white">{f.q}</summary>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutPage;


